export default "__VITE_ASSET__CytIZWkI__"